import React, { useState, useEffect } from "react";
import CommonGrid from "../components/CommonGrid";
import classes from "../components/CommonGrid/commonGrid.module.css";
import { SpinnerBlock } from "../Utils/CustomComponent";
import { Form, Pagination } from "react-bootstrap";
import urls from "../Utils/urls";
import axios from "../axios";

const UserManagment = () => {
  const [apiUsage, setApiusage] = useState();
  const [inputValue, setInputValue] = useState("");
  const [offSet, setOffSet] = useState(0);
  const [hasMore, sethasMore] = useState(false);
  const fetchData = async (numberOff) => {
    setApiusage(null);
    const { data } = await axios.post(urls.admin.postAllUser(numberOff));
    sethasMore(data.hasMore);
    setApiusage(
      data.items?.map((count, index) => {
        const details = JSON.parse(count.details);
        return {
          ...count,
          sn: numberOff === 0 ? index + 1 : numberOff * 25 + (index + 1),
          roleName: details?.role?.map((data) => data?.role_name)?.join(" ,"),
          ...details,
        };
      })
    );
  };
  useEffect(() => {
    fetchData(offSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleApply = async () => {
    const { data } = await axios.post(urls.admin.postUserByEmail(inputValue));
    setApiusage(
      data.items?.map((count, index) => {
        const details = JSON.parse(count.details);
        return {
          ...count,
          sn: index + 1,
          roleName: details.role?.map((data) => data.role_name).join(" ,"),
          ...details,
        };
      })
    );
  };
  const handleReset = async () => {
    fetchData(0);
    setInputValue("");
  };
  return (
    <div>
      <section
        className="rounded"
        style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0 mt-1">
            <h4>User Managment</h4>
          </div>
          <div style={{ background: "#fff", height: "100%", padding: "1rem" }}>
            <div className="d-flex align-items-end">
              <div className="d-flex flex-column me-5">
                <Form.Label style={{ fontWeight: "bold" }}>Email</Form.Label>
                <input
                  style={{
                    lineHeight: "33px",
                    border: "0.7px solid lightgrey",
                  }}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </div>
              <div className="w-25">
                {" "}
                <button
                  className="btn btn-primary text-white btn-outline py-4"
                  style={{ width: "100px" }}
                  onClick={handleApply}
                >
                  Apply
                </button>
                <button
                  className="btn btn-secondary btn-outline py-4"
                  style={{ width: "100px" }}
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>
            {/* {apiUsage ? ( */}
            <CommonGrid
              title={"User Managment"}
              gridColumns={[
                {
                  field: "sn",
                  title: "Sno",
                },
                {
                  field: "roleName",
                  title: "Role",
                },
                {
                  field: "username",
                  title: "Username",
                },
                {
                  field: "first_name",
                  title: "First Name",
                },
                {
                  field: "last_name",
                  title: "Last Name",
                },
                {
                  field: "email",
                  title: "Email",
                },
              ]}
              columnData={apiUsage ? apiUsage : [{ email: "Loading" }]}
              tHeight="18rem"
              numberOfRows={25}
              pagination={
                apiUsage ? (
                  <Pagination className={classes.pagination}>
                    <Pagination.Prev
                      onClick={() => {
                        if (offSet !== 0) {
                          const updatedOff = offSet - 1;
                          setOffSet(updatedOff);
                          fetchData(updatedOff);
                        }
                      }}
                      disabled={offSet === 0}
                    />
                    <Pagination.Next
                      onClick={() => {
                        if (hasMore === true) {
                          const updatedOff = offSet + 1;
                          setOffSet(updatedOff);
                          fetchData(updatedOff);
                        }
                      }}
                      disabled={hasMore !== true}
                    />
                  </Pagination>
                ) : (
                  <SpinnerBlock height="10vh" />
                )
              }
            />
            {/* ) : (
              <SpinnerBlock height="41vh" />
            )} */}
          </div>
        </article>
      </section>
    </div>
  );
};

export default UserManagment;
